module.exports = __webpack_public_path__ + "static/img/swiper_prev.e906255.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/swiper_prev.png
// module id = qwup
// module chunks = 0